:host {
    display: block;

    sew-search-field {
        // minus flyout padding
        margin-top: 132px - 44px;
        width: 100%;
        z-index: 1;
    }

    .links-wrapper {
        // minus flyout padding
        margin: 40px 80px (120px - 40px);
    }

    .links-headline {
        @include typo-ws-paragraph-bold;

        color: $color-grey-01-dark;
    }

    .linklist {
        margin-top: 20px;
        display: flex;

        > div {
            align-items: flex-start;
            display: flex;
            flex-direction: column;
            width: 50%;
            gap: 8px;
        }
    }
}

@include mq-2 {
    :host {
        sew-search-field {
            // minus flyout padding
            margin-top: 80px - 44px;
        }

        .links-wrapper {
            // minus flyout padding
            margin: 40px 64px (100px - 40px);
        }

        .linklist {
            flex-direction: column;
            gap: 24px;
            width: 100%;
        }
    }
}

@include mq-1 {
    :host {
        sew-search-field {
            // minus flyout padding
            margin-top: 60px - 44px;
        }

        .links-wrapper {
            // minus flyout padding
            margin-bottom: 80px - 40px;
        }
    }
}
